import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { EmailSettingsGridComponent } from './email-settings-grid/email-settings-grid.component';

@Component({
    selector: 'app-email-settings',
    templateUrl: './email-settings.component.html',
    styleUrls: ['./email-settings.component.scss'],
    imports: [TitleBarComponent, EmailSettingsGridComponent, TranslateModule]
})
export class EmailSettingsComponent {

  constructor() {
  }
}
